import { render, staticRenderFns } from "./Technical.vue?vue&type=template&id=bc6a4ec8&scoped=true&"
import script from "./Technical.vue?vue&type=script&lang=js&"
export * from "./Technical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6a4ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc6a4ec8')) {
      api.createRecord('bc6a4ec8', component.options)
    } else {
      api.reload('bc6a4ec8', component.options)
    }
    module.hot.accept("./Technical.vue?vue&type=template&id=bc6a4ec8&scoped=true&", function () {
      api.rerender('bc6a4ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/Technical.vue"
export default component.exports